/**
 * Plans a portal post can be targeted at.
 *
 * Values are the Tools Service enum for `ZenoToolsPost.rules.plans.values` — the client only
 * sends them, `getPortalPostsForUser` matches them server-side. Labels are locale keys because
 * `PostRules.vue` builds the select options with `$t` at render time.
 *
 * `TRIAL_POST_PLANS` is what gates the `maxTimeToTrialEnd` input, so a new trial-flavoured plan
 * has to be listed there as well as in `POST_PLANS`.
 *
 * @typedef {{ value: string, labelKey: string }} PostPlan
 */

export const POST_PLAN = Object.freeze({
  FREE: "FREE",
  TRIAL: "TRIAL",
  TRIAL_STARTER: "TRIAL_STARTER",
  TRIAL_PRIME: "TRIAL_PRIME",
  TRIAL_PREMIER: "TRIAL_PREMIER",
  ACTIVE_SUBSCRIBERS: "ACTIVE_SUBSCRIBERS",
  ACTIVE_STARTER: "ACTIVE_STARTER",
  ACTIVE_PRIME: "ACTIVE_PRIME",
  ACTIVE_PREMIER: "ACTIVE_PREMIER",
})

/** @type {PostPlan[]} */
export const POST_PLANS = [
  { value: POST_PLAN.FREE, labelKey: "posts.rules.plan_free" },
  { value: POST_PLAN.TRIAL, labelKey: "posts.rules.plan_trial" },
  { value: POST_PLAN.TRIAL_STARTER, labelKey: "posts.rules.plan_trial_starter" },
  { value: POST_PLAN.TRIAL_PRIME, labelKey: "posts.rules.plan_trial_prime" },
  { value: POST_PLAN.TRIAL_PREMIER, labelKey: "posts.rules.plan_trial_premier" },
  { value: POST_PLAN.ACTIVE_SUBSCRIBERS, labelKey: "posts.rules.plan_active" },
  { value: POST_PLAN.ACTIVE_STARTER, labelKey: "posts.rules.plan_active_starter" },
  { value: POST_PLAN.ACTIVE_PRIME, labelKey: "posts.rules.plan_active_prime" },
  { value: POST_PLAN.ACTIVE_PREMIER, labelKey: "posts.rules.plan_active_premier" },
]

export const TRIAL_POST_PLANS = [
  POST_PLAN.TRIAL,
  POST_PLAN.TRIAL_STARTER,
  POST_PLAN.TRIAL_PRIME,
  POST_PLAN.TRIAL_PREMIER,
]
